<template>
<main class="notice">
  <h1 class="heading-common is-btn-back"><a class="btn-back" @click="back"></a> {{ $t('notice.title_detail') }}</h1>

  <!-- Container -->
  <section class="container">
    <div class="box notice-detail" v-show="news.length && newsData">
      <div class="title">{{ $t(`news[${newsId}].title`) }}</div>
      <div class="date">{{ newsData && newsData.open_date ? newsData.open_date : '' }}</div>
      <div class="detail" v-html="$t(`news[${newsId}].detail`)"></div>
    </div>
  </section>
</main>

</template>

<script>
  import {api} from "../../config";
  import { mapActions, mapGetters, mapState } from 'vuex'

  export default {
    data () {
      return {
        newsId: null,
      }
    },
    computed: {
      ...mapState({
        user: state => state.auth
      }),
      news() {
         return this.$store.getters.newslist
      },
      newsData() {
         return this.newsId ? this.$store.getters.newslist.find(item => item.news_id == this.newsId) : null
      },
    },

    created() {
      this.newsId = this.$route.params['news_id']
      
      if(!this.$store.getters.newslist || this.$store.getters.newslist.length == 0) {
        this.$store.dispatch('getNewsList')
      }
    },

    mounted() {
      
      if(this.newsId) {
        // mark as read
        axios.post(api.newsMarkAsRead, { type: 'news', news_id: this.newsId })
      }
    },
    methods: {
      
      back() {
        this.$router.push({name: 'notice'})
      }
    },
  }
</script>

<style scoped>
  .temporary {
    text-align: center;
    padding: 50px;
    border: 1px solid black;
  }
</style>
